<template>
	<div id="app">
		<vue-scroll :ops="ops" @handle-scroll="handleScroll" ref="bodyScroll">
			<app-header></app-header>
			<router-view @requestView02="requestView" />
			<app-footer @goToTop="btnTop"></app-footer>
		</vue-scroll>
	</div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
	name: "App",
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: "CREATIVE GROUP XEOGEN",
		// all titles will be injected into this template
		titleTemplate: "%s | CREATIVE GROUP XEOGEN",
		link: [{ rel: "canonical", href: "www.xeogen.com" }],
		meta: [
			{ charset: "utf-8" },
			{
				name: "viewport",
				content:
					"width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=5.0,user-scalable=yes",
			},
			{
				vmid: "description",
				name: "description",
				content:
					"항상 최고의 서비스를 제공하고 미래가치를 발전시켜 나가는 크리에이티브 그룹 제오젠입니다.",
			},
			{
				vmid: "keywords",
				name: "keywords",
				content: "XEOGEN, 웹에이전시, WebAgency, Creative",
			},
		],
	},
	data() {
		return {
			scrollTop: false,
			ops: {
				vuescroll: {
					detectResize: false,
				},
				scrollPanel: {
					speed: 100,
					easing: "easeInQuad",
					scrollingX: false,
				},
				bar: {
					background: "#c1c1c1",
					showDelay: 300,
					size: "6px",
				},
			},
		};
	},
	components: {
		"app-header": Header,
		"app-footer": Footer,
	},
	methods: {
		handleScroll(vertical, horizontal, nativeEvent) {
			//console.log(vertical.scrollTop);
			if (this.$route.name == "xgAboutus") this.aboutUsPartner();
		},
		aboutUsPartner() {
			let winH = $(window).outerHeight();
			$(".partner-list")
				.find("li")
				.each(function () {
					if (!$(this).hasClass("is-view")) {
						var top = Math.ceil($(this).offset().top);
						var thisH = Math.ceil($(this).outerHeight());
						if (top <= winH - thisH) {
							$(this).addClass("is-view");
						}
					}
				});
		},
		requestView(target) {
			this.$refs["bodyScroll"].scrollIntoView(target, 200);
		},
		btnTop() {
			this.$refs["bodyScroll"].scrollTo({ y: 0 }, 200);
		},
	},
	watch: {
		$route(to, from) {
			if (to.path != from.path) {
				this.$refs["bodyScroll"].scrollTo({ y: 0 }, 0);
			}
		},
	},
	created() {
		// this.$xgRecruit.$on("toggle-team", function (target) {
		// 	console.log(target);
		// });
	},
};
</script>
<style>
@import "../static/css/jquery-ui.min.css";
@import "../static/css/swiper.min.css";
/* @import "../node_modules/vue2-animate/dist/vue2-animate.min.css"; */
@import "../static/css/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue